import { BRAND, PAYMENT_HANDLES } from "@/lib/data";
import { SocialLinks } from "@/components/site/SocialLinks";

export const Footer = () => {
  const go = (href) => document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  const year = new Date().getFullYear();

  return (
    <footer data-testid="footer" className="relative bg-[#050505] pt-20 pb-10 overflow-hidden">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 pb-16 border-b border-[#1a1a1a]">
          <div className="md:col-span-6">
            <h3 className="font-display uppercase text-white leading-[0.9] text-5xl sm:text-7xl">
              Saving one
              <br />
              <span className="text-green glow-green">soul</span> at a time
            </h3>
            <button
              data-testid="footer-donate"
              onClick={() => go("#donate")}
              className="btn-fill mt-8 border border-green text-green font-sub font-semibold px-8 py-3.5 rounded-full"
            >
              Donate now
            </button>
            <SocialLinks className="mt-10" />
          </div>

          <div className="md:col-span-3 md:col-start-8">
            <p className="label mb-5">Navigate</p>
            <ul className="space-y-3 font-sub text-zinc-400">
              {["Mission", "Gallery", "Impact", "Volunteer", "Contact"].map((l) => (
                <li key={l}>
                  <button onClick={() => go(`#${l.toLowerCase()}`)} className="hover:text-green transition-colors">
                    {l}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <p className="label mb-5">Give Directly</p>
            <ul className="space-y-3 font-sub text-zinc-400">
              <li>Zelle · <span className="text-white">{PAYMENT_HANDLES.zelle}</span></li>
              <li>Cash App · <span className="text-white">{PAYMENT_HANDLES.cashapp}</span></li>
              <li>maskgiver.com</li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col md:flex-row items-center justify-between gap-4 pt-8">
          <span className="flex items-center gap-2 font-display text-2xl">
            <span className="text-white">M</span><span className="text-green">G</span>
            <span className="label ml-2">{BRAND.name}</span>
          </span>
          <p className="font-sub text-sm text-zinc-600">© {year} Mask Giver. Made with purpose.</p>
        </div>
      </div>
    </footer>
  );
};
